var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M24 12a12 12 0 1 0-13.88 11.85v-8.38H7.08V12h3.04V9.36c0-3.01 1.8-4.67 4.54-4.67 1.31 0 2.68.23 2.68.23v2.96h-1.5c-1.5 0-1.96.92-1.96 1.87V12h3.32l-.53 3.47h-2.8v8.38A12 12 0 0 0 24 12"}));
}

Facebook.defaultProps = {"width":"24","height":"24","aria-label":"facebook icon","viewBox":"0 0 24 24"};

module.exports = Facebook;

Facebook.default = Facebook;
